import script from "./People.vue?vue&type=script&setup=true&lang=js"
export * from "./People.vue?vue&type=script&setup=true&lang=js"

import "./People.vue?vue&type=style&index=0&id=c4f40d18&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4f40d18"]])

export default __exports__